//
import Model from "@/models/Model"
import AuthorizeModel from "@/models/Actions/AAuthorize"
import RejectModel from "@/models/Actions/AReject"

/**
 * This class describes a wh stock adjust.
 *
 * @class      WhStockAdjust (name)
 */
export default class WhStockAdjust extends Model {

    //
    wh_selected_products = []

    /**
     * 
     */
    static includes = [
        "g_user.hr_employee",
        "wh_detail_stock_adjusts.wh_product",
        "wh_inventory",
        "wh_stock_adjust_type",
        "wh_warehouse",
    ]

    /**
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    authorize() {
        return this.hasMany(AuthorizeModel)
    }

    /**
     * 
     */
    create () {

        //
        this.details = this.wh_selected_products.map( this.mapDetail )

        //
        return this.clean([ "description", "details", "wh_stock_adjust_type_id", "wh_warehouse_id" ]).save()
    }

    /**
     * 
     */
    get g_user_name () {
        return [
            this.g_user.hr_employee.names,
            this.g_user.hr_employee.last_name1,
            this.g_user.hr_employee.last_name2,
        ].join(" ")
    }

    /**
     * { property_description }
     *
     * @type       {boolean}
     */
    get state() {
        return this.is_confirmed ? 'Confirmada' : 'Pendiente'
    }

    /**
     * 
     */
    get wh_stock_adjust_type_name () {
        return this.wh_stock_adjust_type.type
    }

    /**
     * 
     */
    get wh_warehouse_name () {
        return this.wh_warehouse.name
    }

    /**
     * 
     */
    mapDetail ( item ) {
        return {
            quantity        : Number( item.quantity ),
            wh_product_id   : Number( item.wh_product_id ),
        }
    }
    
    /**
     * 
     */
    mapSelected ( item ) {
        return {
            ...item.wh_product,
            quantity        : Number( item.quantity ),
            wh_product_id   : Number( item.wh_product_id ),
        }
    }

    /**
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    reject() {
        return this.hasMany(RejectModel)
    }

    /**
     * 
     */
    reset () {

        //
        this.wh_selected_products = this.wh_detail_stock_adjusts.map( this.mapSelected )

        //
        return this
    }

    /**
     * 
     */
    resource () {
        return "wh_stock_adjust"
    }

    /**
     * Returns an authorize representation of the object.
     *
     * @return     {<type>}  Authorize representation of the object.
     */
    toAuthorize() {
        return this.clean([
            'confirm_description',
        ])
    }

    /**
     * Returns a reject representation of the object.
     *
     * @return     {<type>}  Reject representation of the object.
     */
    toReject() {
        return this.clean([
            'confirm_description',
        ])
    }
}